import Flex from "common/Boxes/Flex";
import { Skeleton } from "common/Skeleton/Skeleton";
import { ACCOUNT_TABLE_CHART_HEIGHT } from "features/portfolio/Accounts/AccountTableChart";
import React, { CSSProperties } from "react";

interface ChartSkeletonProps {
  style?: CSSProperties;
  active?: boolean;
}

const ChartSkeleton = ({ style, active = true }: ChartSkeletonProps) => {
  return (
    <Flex
      $justifyContent="center"
      $flexDirection="column"
      style={{ width: "100%", ...style }}
    >
      <Skeleton
        paragraph={false}
        active={active}
        style={{
          width: "100%",
        }}
        $height={ACCOUNT_TABLE_CHART_HEIGHT}
      />
      <Skeleton
        paragraph={false}
        active={active}
        style={{
          width: 40,
          marginTop: 3,
        }}
        $height={9}
      />
    </Flex>
  );
};

export default ChartSkeleton;
